
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDockLeftGoogle as ObiDockLeftGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-dock-left-google.js';
 
 
 

 
 export const ObiDockLeftGoogle = createComponent({
   react: React,
   tagName: 'obi-dock-left-google',
   elementClass: ObiDockLeftGoogleElement,
   events: {
     
   }
  });
 
 